import React, { useContext, useEffect, useState } from 'react';
import { Default as Alert } from '@gjensidige/core-alerts';
import { useForm } from 'react-hook-form';
import { Input } from '../../../common/Form/Input';
import { text } from '../../../../utils/text';
import { NavigationButtons } from '../../../common/NavigationButtons/NavigationButtons';
import { Card } from '../../../common/Card/Card';
import { PersonvernInfoButton } from '../../../common/PersonvernInfoModal/PersonvernInfoButton/PersonvernInfoButton';
import { scenarioSteps, trackScenario } from '../../../../tracking';
import { LOGGER_ENDPOINT, submitFormData, validateCustomer } from '../../../../utils/api';
import { Action, RoutePath } from '../../../../utils/types';
import { yupResolver } from '@hookform/resolvers/yup';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { isValidSsn } from '@gjensidige/gpf-js-utils/es6/validation/ssn';
import { Form } from '../../../common/Form/Form';
import { Layout } from '../../../common/Layout/Layout';
import { useFormState } from '../../../../context/FormContext';
import sizing from '../../../../utils/sizing.module.less';
import { getCustomerAge, getFormPayload } from '../../../../utils/utils';
import { useGlobalContext } from '../../../../context/GlobalContext';
import { remoteLogError } from '@gjensidige/gpf-js-utils/es6/logging/error-handler';
import { FeatureFlagsContext } from '../../../../AppWrapper';
export const AboutForm = () => {
    const [errorMessage, setErrorMessage] = useState(undefined);
    const [warningMessage, setWarningMessage] = useState(undefined);
    const [isValidating, setIsSubmitting] = useState(false);
    const [{ sellerRef }, dispatch] = useGlobalContext();
    const formState = useFormState();
    const history = useHistory();
    const featureFlags = useContext(FeatureFlagsContext);
    const { handleSubmit, control } = useForm({
        resolver: yupResolver(customerValidationSchema),
        defaultValues: formState.customerData,
        reValidateMode: 'onChange',
        mode: 'onBlur',
    });
    useEffect(() => {
        trackScenario(scenarioSteps.ABOUT);
    }, []);
    const submit = (customerData) => {
        const age = getCustomerAge(customerData.ssn);
        if (age >= 65 && warningMessage == undefined) {
            setWarningMessage(text.FORM.ABOUT_FORM.VALIDATION.AGE_WARNING(age).no);
        }
        else {
            setIsSubmitting(true);
            validateCustomer(customerData.ssn, customerData.firstName, customerData.surname).then((result) => {
                if (result.isOk()) {
                    const data = getFormPayload(Object.assign(Object.assign({}, formState), { customerData }), sellerRef, featureFlags);
                    submitFormData(data).then((result) => {
                        if (result.isOk()) {
                            const { requestId, signingUrl } = result.value;
                            dispatch({
                                type: Action.UPDATE_SIGNING_PARAMS,
                                signingParams: { requestId, signingUrl },
                            });
                            history.push(`/signing/${requestId}`);
                        }
                        else {
                            void remoteLogError(LOGGER_ENDPOINT, new Error(result.error.message)).then(() => setErrorMessage(text.COMMON.UNKNOWN_EXCEPTION_MESSAGE.no));
                        }
                    });
                }
                else {
                    void remoteLogError(LOGGER_ENDPOINT, new Error(result.error.message)).then(() => setErrorMessage(text.FORM.ABOUT_FORM.VALIDATION.VALIDATION_FAILED.no));
                }
                setIsSubmitting(false);
            });
        }
    };
    return (React.createElement(Layout, { title: text.LAYOUT.START_SAVING.TITLE.no },
        React.createElement(Card, { step: 7, maxStep: 7, title: text.FORM.ABOUT_FORM.TITLE.no, subtitle: text.FORM.ABOUT_FORM.DESCRIPTION.no },
            React.createElement(Form, { onSubmit: handleSubmit(submit) },
                React.createElement(Input, { name: 'firstName', id: 'firstName', labelText: text.FORM.ABOUT_FORM.FIRSTNAME.LABEL_TEXT.no, control: control }),
                React.createElement(Input, { name: 'surname', id: 'surname', labelText: text.FORM.ABOUT_FORM.SURNAME.LABEL_TEXT.no, control: control }),
                React.createElement(Input, { name: 'email', id: 'email', labelText: text.FORM.ABOUT_FORM.EMAIL.LABEL_TEXT.no, control: control }),
                React.createElement(Input, { name: 'ssn', id: 'ssn', inputMode: 'numeric', labelText: text.FORM.ABOUT_FORM.SSN.LABEL_TEXT.no, helpText: text.FORM.ABOUT_FORM.SSN.HELP_TEXT.no, inputWrapperClassName: sizing.mw160, control: control }),
                errorMessage && React.createElement(Alert, { alertType: "error", text: errorMessage }),
                warningMessage && React.createElement(Alert, { alertType: "warning" }, warningMessage),
                React.createElement(PersonvernInfoButton, null),
                React.createElement(NavigationButtons, { isSubmit: true, nextText: text.NAV_BUTTONS.SUBMIT.no, onPrevious: () => history.push(RoutePath.SUMMARY), loading: isValidating })))));
};
const customerValidationSchema = yup.object().shape({
    firstName: yup.string().required(text.FORM.ABOUT_FORM.FIRSTNAME.VALIDATION.REQUIRED.no),
    surname: yup.string().required(text.FORM.ABOUT_FORM.SURNAME.VALIDATION.REQUIRED.no),
    email: yup
        .string()
        .required(text.FORM.ABOUT_FORM.EMAIL.VALIDATION.REQUIRED.no)
        .email(text.FORM.ABOUT_FORM.EMAIL.VALIDATION.INVALID.no),
    ssn: yup
        .string()
        .required(text.FORM.ABOUT_FORM.SSN.VALIDATION.REQUIRED.no)
        .test('isValidSsn', text.FORM.ABOUT_FORM.SSN.VALIDATION.INVALID.no, (value) => isValidSsn(value))
        .test('age', text.FORM.ABOUT_FORM.SSN.VALIDATION.INVALID_AGE.no, (value) => isValidAge(value)),
});
const isValidAge = (ssn) => {
    return ssn ? getCustomerAge(ssn) >= 18 : false;
};
